import client from "./clients/portalClient";

const getALlDates = () => client.get(`/productivity`);
const postNewYearData = (data) => client.post(`/productivity`, data);
const editExistingYearData = (id, data) => client.put(`/productivity/${id}`, data);
const deleteYearData = (id) => client.delete(`/productivity/${id}`);

const getEverythingForBudgetRules = () => client.get(`/productivity_details`);

const adminBudgetApi = {
    getALlDates,
    postNewYearData,
    editExistingYearData,
    deleteYearData,
    getEverythingForBudgetRules
};

export default adminBudgetApi;
